import SeasonalActivity from './SeasonalActivity';
import './SeasonalActivity.scss';

export default SeasonalActivity;